import { useState, useEffect } from "react";

const Banner = ({ currentCompany, baseMargin }) => {
  const [bgNum, setBgNum] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setBgNum(Math.floor(Math.random() * 50) + 1);
    requestAnimationFrame(() => setVisible(true));
  }, []);

  if (bgNum === null) return null;

  const pad = Math.max(baseMargin, 24) + 24;

  return (
    <div style={{ position: "relative", minHeight: 200, overflow: "hidden" }}>
      {/* Background photo */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${require(`../../../assets/images/dd_img_prod/${bgNum}.jpg`)})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          transition: "transform 12s ease-out",
          transform: visible ? "scale(1.06)" : "scale(1)",
        }}
      />

      {/* Gradient overlay — photo legibility, not a palette token */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.35) 50%, rgba(0,0,0,0.75) 100%)",
        }}
      />

      {/* Text */}
      <div
        className="font-poppins"
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          paddingBottom: 20,
          paddingLeft: pad,
          paddingRight: pad,
        }}
      >
        <p
          style={{
            fontSize: 28,
            fontWeight: 500,
            color: "rgba(255,255,255,0.95)",
            letterSpacing: "-0.01em",
            textShadow: "0 2px 12px rgba(0,0,0,0.4)",
            transition: "all 0.7s ease-out",
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(12px)",
            margin: 0,
          }}
        >
          {currentCompany?.case}
        </p>
        <p
          style={{
            fontSize: 11,
            fontWeight: 400,
            color: "rgba(255,255,255,0.45)",
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            marginTop: 4,
            transition: "all 0.7s ease-out 0.15s",
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(8px)",
          }}
        >
          Wiki · Overview
        </p>
      </div>
    </div>
  );
};

export default Banner;
